import React from "react";

import StoryCard8 from "../../molecules/story-card8";
import CollectionName from "../../molecules/collection-name";
import { filterStory } from "../../helper/api";

import "./six-story-grid.m.css";

const SixStoyGrid = ({ collection }) => {
  if (!(collection && collection.items)) {
    return null;
  }
  const stories = filterStory(collection);

  const MobileStories = [...stories];

  if (!stories.length) {
    return null;
  }

  const cardTypeProps = {
    aspectRatio: [2, 3],
    imageType: "image2x3"
  };

  const getStories = (fullCards, cards) => {
    return (
      <div styleName="wrapper">
        {cards.splice(0, 6).map((item, index) => (
          <div styleName={`card${index + 1}`} className="grid-card" key={index}>
            <StoryCard8 story={item} key={index} {...(fullCards.includes(index) ? { ...cardTypeProps } : {})} />
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <CollectionName collection={collection} />
      <div className="hide-mobile">{getStories([0, 2, 4], stories)}</div>
      <div className="hide-desktop">{getStories([0, 3, 4, 5], MobileStories)}</div>
    </>
  );
};

export default SixStoyGrid;
